// import { updateWidgetFieldEdit } from '@/store/modules/widgetEditor/actions';
import { editField } from '@/store/modules/widgetEditor/getters';
import set from 'lodash/set';
import { mapActions, mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters([editField.fullPath]),
		localField: {
			set(value) {
				// this[updateWidgetFieldEdit.fullPath](value);
				this.updateWidgetFieldEdit(value);
			},
			get() {
				return this[editField.fullPath];
			},
		},
		prefillEnabled: {
			get() {
				return this.localField.metadata.options['prefill'].enabled;
			},
			set(value) {
				if (!('prefill' in this.localField.metadata.options)) {
					this.setLocalFieldKey('metadata.options.prefill', {});
				}
				this.setLocalFieldKey('metadata.options.prefill.enabled', value);
			},
		},
		prefillValue: {
			get() {
				return this.localField.metadata.options['prefill'].value;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.prefill.value', value);
			},
		},
		fieldIdentifier: {
			get() {
				try {
					return this.localField.metadata.options.identifier.value;
				} catch {
					return 'Field Identifier';
				}
			},
			set(value) {
				if (!('identifier' in this.localField.metadata.options)) {
					this.setLocalFieldKey('metadata.options.identifier', {});
				}
				this.setLocalFieldKey('metadata.options.identifier.value', value);
			},
		},
		titleEnabled: {
			get() {
				return this.localField.metadata.options.title.enabled;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.title.enabled', value);
			},
		},
		titleValue: {
			get() {
				return this.localField.metadata.options.title.value;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.title.value', value);
			},
		},
		requiredEnabled: {
			get() {
				return this.localField.metadata.options.required.enabled;
			},
			set(value) {
				if (!('required' in this.localField.metadata.options)) {
					this.setLocalFieldKey('metadata.options.required', {});
				}
				this.setLocalFieldKey('metadata.options.required.enabled', value);
			},
		},
		descriptionEnabled: {
			get() {
				return this.localField.metadata.options.description.enabled;
			},
			set(value) {
				if (!('description' in this.localField.metadata.options)) {
					this.setLocalFieldKey('metadata.options.description', {});
				}
				this.setLocalFieldKey('metadata.options.description.enabled', value);
			},
		},
		descriptionValue: {
			get() {
				return this.localField.metadata.options.description.value;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.description.value', value);
			},
		},
		placeholderEnabled: {
			get() {
				return this.localField.metadata.options.placeholder.enabled;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.placeholder.enabled', value);
			},
		},
		placeholderValue: {
			get() {
				return this.localField.metadata.options.placeholder.value;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.placeholder.value', value);
			},
		},
	},
	methods: {
		// ...mapActions([updateWidgetFieldEdit.fullPath]),
		...mapActions('widgetEditor', ['updateWidgetFieldEdit']),
		setLocalFieldKey(key, value) {
			this.localField = set(this.localField, key, value);
			this.$set(this.localField, 'id', this.localField.id); // for reactivity purposes
		},
		updateValidationValue(optionKey, value) {
			this.setLocalFieldKey(`metadata.validations.${optionKey}.value`, value);
		},
		updateValidationEnabled(optionKey, value) {
			this.setLocalFieldKey(`metadata.validations.${optionKey}.enabled`, value);
		},
	},
};
